import type {ColumnProps} from "./types.ts";

/**
 * Column Component for both Table and SortableTable.
 */
export default function Column(props: ColumnProps) {
    return null;
}
